const EXTENDED_ROW_LIMIT_PARTNER_ID = 441;

export function sourceSchainMaxSizePrepareLine(partnerId: number | undefined): string {
  if (partnerId === EXTENDED_ROW_LIMIT_PARTNER_ID) {
    return 'Max size: 15 MB / 30k lines';
  }

  return 'Max size: 15 MB / 15k lines';
}

export function sourceSchainRowLimitDescription(partnerId: number | undefined): string {
  if (partnerId === EXTENDED_ROW_LIMIT_PARTNER_ID) {
    return 'Maximum 30,000 lines/sources per file';
  }

  return 'Maximum 15,000 lines/sources per file';
}
